/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface EnrollmentCommitResponse {
  workflow_id: string;
  /** @minimum 0 */
  enrollment_count: number;
  enrollment_ids: string[];
}
